import React, { FC } from "react";
import { IOptionSelect } from "src/@types/form";
import cn from "classnames";
import { Button } from "../Button";

interface Props {
  isActive: boolean;
  option: IOptionSelect;
  onClick: VoidFunction;
  className?: string;
}

export const ButtonSelectorItem: FC<Props> = ({
  option,
  isActive,
  onClick,
  className,
}) => {
  return (
    <Button
      type="button"
      className={cn(
        "w-full min-h-11 px-3 py-1.5 flex-1 text-10 rounded-lg border-r md:text-base border-white-base last:border-none md:min-h-max lg:px-6 lg:py-3.5",
        {
          "text-green-base bg-white-base": isActive,
          "text-white-base": !isActive,
        },
        className
      )}
      onClick={onClick}
    >
      {option.label}
    </Button>
  );
};
